<template>
    <div class="container">
        <div class="container-head">热门问题</div>
        <div class="container-box">
            <template v-for="(item,index) in listContent">
                <div class="container-box-item"   v-if="index<10" :key="index">
                    <div class="container-box-item-head">{{item.helpActicleTypeNameCn}}</div>
                    <div class="container-box-item-content">
                        <ul>
                            <template  v-for="(item1,index1) in item.content">
                                <li :key="index1" v-if="index1<5" @click="goDetailInfo(item1,index)">{{item1.nameCn}}</li>
                            </template>
                            <li class="text-more" v-if="item.content.length>5"  style="text-align:left;margin-top:14px" @click="getIndex(item)">更多 
                                <img class="no-hover" style="position: relative;top: -2px;" src="../assets/img/right.png" alt="">
                                <img class="hover" style="position: relative;top: -2px;" src="../assets/img/right_hover.png" alt="">
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
// import {getHelpActicleListForPc} from '@/api/api.js'
export default {
    name: 'home',
    props:{
        listContent:{
            type: Array,
            default: () => ({
                a:1,
                b:2
            })
        }
    },
    data() {
        return {
            
        }
    },
    methods:{
        getIndex(item){
            this.$parent.sortList.forEach((parentitem,index) => {
               if(parentitem.nameCn == item.helpActicleTypeNameCn){
                   this.$parent.getIndex(index)
               }
            });
        },
        goDetailInfo(item1,index){
            this.$parent.goDetailInfo(item1,index);
            // console.log(item1)
        }
    }
}
</script>
<style scoped lang="less">
    .container{
        height:100%;
        .container-head{
            font-size: 14px;
            margin-bottom: 10px;
            text-align: left;
            color: #999;

        }
        .container-box{
            display: flex;
            flex-wrap:wrap;
            .container-box-item{
                background:#fff;
                width:470px;
                padding:20px;
                margin: 0 20px 20px 0;
                text-align: left;
                position: relative;
                .container-box-item-head{
                    font-size: 18px;
                    font-weight: 700;
                    margin-bottom: 15px;
                    color:#333;
                }
                .text-more{
                    font-size: 12px;
                    color:#999;
                    float: right;
                    position: absolute;
                    top: 10px;
                    right: 20px;
                }
                .container-box-item-content{
                    font-size: 12px;
                    li{
                        margin:20px 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color:#333;
                        font-size: 14px;
                        .hover{
                            display:none;
                        }
                        cursor: pointer;
                        &:hover{
                            color: #4646fd;
                            .hover{
                                display:inline-block;
                            }
                            .no-hover{
                                display:none;
                            }
                        }
                        &:nth-child(1){
                            margin-top: 26px;
                        }
                        &:nth-child(5){
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }

    }
    
</style>
